const reasons = [
  {
    title: 'WIDE RANGE OF PROPERTIES',
    desc: 'With a robust selection of popular properties on hand, as well as leading properties from experts.',
  },
  {
    title: 'FINANCING MADE EASY',
    desc: 'Our stress-free finance department that can find financial solutions to save you money.',
  },
  {
    title: 'TRUSTED BY THOUSANDS',
    desc: '10 new offers every day. 350 offers on site, trusted by a community of thousands of users',
  },
  {
    title: 'GET IMPORTANT NOTIFICATIONS',
    desc: 'Receive advices, listings, and neighborhood information',
  },
  {
    title: 'TRANSPARENCY',
    desc: 'You and your landlord always see the same info, and you will get all important information directly to your post office',
  },
  {
    title: 'NEAR BY ME',
    desc: 'Search near top-rated schools and explore neighborhoods.',
  },
];

export default reasons;
